import BackendNotificationsReducer from './BackendNotificationsReducer';

export default from './BackendNotificationsContainer';
export * as actions from './BackendNotificationsActions';

export const BackendNotificationsReducers = {
  BackendNotificationsReducer,
};
